const namespace = "cancelledTournament";

export const MESSAGE = `${namespace}.message`;
export const CONFIRM = `${namespace}.confirm`;
